export const MUSIC_RIBBON_TYPE = 'genericClaroMusicaRibbon';
export const REMOVE_RIBBON = 'remover / {{RIBBON_NAME}}';
export const RIBBON_NAME = '{{RIBBON_NAME}}';
export const NODE_RIBBONS = 'carruseles {{NODE_NAME}}';



// WEBPACK FOOTER //
// ./src/components/RibbonGridNew/constants.js